const branch = [
  {
    label: "CSE",
    value: "CSE",
  },
  {
    label: "CS",
    value: "CS",
  },
  {
    label: 'CSML',
    value: 'CSML',
  },
  {
    label: 'CSAI',
    value: 'CSAI',
  },
  
  {
    label: "IT",
    value: "IT",
  },
  {
    label: "CSIT",
    value: "CSIT",
  },
  {
    label: "ECE",
    value: "ECE",
  },
  {
    label: "EN",
    value: "EN",
  },
  {
    label: "MECHANICAL",
    value: "MECHANICAL",
  },
  {
    label: 'CIVIL',
    value: 'CIVIL',
  },
  {
    label: 'MBA',
    value: 'MBA',
  },
  {
    label: 'MCA',
    value: 'MCA',
  },
  {
    label: 'BPHARMA',
    value: 'BPHARMA',
  },
];

export default branch;
